import { defineMessages } from 'react-intl';
import type { IntlShape } from 'react-intl';

const messages = defineMessages({
  titleBlock: {
    id: 'mpf_servicos_destaque_block',
    defaultMessage: 'Serviços em Destaque',
  },
  items: {
    id: 'mpf_servicos_destaque_items',
    defaultMessage: 'Serviços',
  },
  item: {
    id: 'mpf_servicos_destaque_item',
    defaultMessage: 'Serviço',
  },
  servico: {
    id: 'mpf_servicos_destaque_servico',
    defaultMessage: 'Serviço do catálogo',
  },
  servicoHelp: {
    id: 'mpf_servicos_destaque_servico_help',
    defaultMessage:
      'Selecione um serviço do catálogo oficial. O rótulo e o link vêm automaticamente do catálogo — não é possível editá-los aqui, apenas escolher qual serviço aparece.',
  },
});

/**
 * Schema de cada item da lista: só o seletor do serviço, sem campo de
 * rótulo — RF05 exige que o rótulo venha travado do catálogo, o editor
 * comum não pode digitar/alterar o texto exibido.
 */
const servicoItemSchema = ({ intl }: { intl: IntlShape }) => ({
  title: intl.formatMessage(messages.item),
  addMessage: intl.formatMessage(messages.item),
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['servico'],
    },
  ],
  properties: {
    servico: {
      title: intl.formatMessage(messages.servico),
      description: intl.formatMessage(messages.servicoHelp),
      widget: 'object_browser',
      mode: 'link',
      selectableTypes: ['Servico'],
      selectedItemAttrs: ['@id', '@type', 'Title', 'url', 'icone'],
      allowExternals: false,
      initialPath: '/',
    },
  },
  required: ['servico'],
});

/** Ver `AcoesRapidas/schema.ts` sobre `activeObject`/`setActiveObject`. */
export const mpfServicosDestaqueSchema = ({
  intl,
  activeObject,
  setActiveObject,
}: {
  intl: IntlShape;
  activeObject?: number;
  setActiveObject?: (index: number) => void;
}) => ({
  title: intl.formatMessage(messages.titleBlock),
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['items'],
    },
  ],
  properties: {
    items: {
      title: intl.formatMessage(messages.items),
      widget: 'object_list',
      schema: servicoItemSchema({ intl }),
      activeObject,
      setActiveObject,
    },
  },
  required: [],
});

export default mpfServicosDestaqueSchema;
